// ** Third Party
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const MySwal = withReactContent(Swal);
export { Swal };

// Title text color by alert type.
export const getClassNameByType = (type) => {
  switch (type) {
    case 'success':
      return 'text-success';
    case 'error':
      return 'text-danger';
    case 'info':
    case 'question':
      return 'text-info';
    default:
      return 'text-warning';
  }
};

// Bootstrap button class from a color shorthand, e.g. 'success' -> 'btn btn-success'.
export const buttonClass = (color = 'outline-secondary') => `btn btn-${color}`;

/**
 * Render any number of custom buttons inside a SweetAlert modal.
 * Each button is { text, color, onClick? } — clicking it runs onClick (if any) then closes.
 * `onClose` (optional) runs only when the modal is dismissed (outside click / Esc / X),
 * never when a button is clicked — use it for cleanup that must happen on any non-button exit.
 */
export const fireCustomButtons = ({
  title,
  text = '',
  type = 'warning',
  buttons = [],
  onClose,
  allowOutsideClick = true
}) => {
  let closedByButton = false;

  return MySwal.fire({
    title: `<span class="${getClassNameByType(type)} fs-3">${title}</span>`,
    icon: type ? type : false,
    allowOutsideClick,
    showConfirmButton: false,
    showCancelButton: false,
    buttonsStyling: false,
    html: (
      <div className="text-center">
        {text && <div className="fs-6 fw-bold text-secondary">{text}</div>}
        <div className="d-flex flex-wrap justify-content-center mt-2">
          {buttons.map(({ text: label, color, onClick }, i) => (
            <button
              key={`cc-btn-${i}`}
              type="button"
              className={`${buttonClass(color)} ${i ? 'ms-1' : ''}`}
              onClick={() => {
                closedByButton = true;
                if (typeof onClick === 'function') onClick();
                MySwal.close();
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    )
  }).then(() => {
    if (!closedByButton && typeof onClose === 'function') onClose();
  });
};
